export const CONNEXION_TYPE_COOKIE_NAME = 'M_TCO';
